"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8632],{

/***/ 12265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

function SvgArrowDownCurved(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ width: 90, height: 108, xmlns: "http://www.w3.org/2000/svg" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("g", { fill: "none", fillRule: "evenodd", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          d: "M1 0c.03 22.374 12.227 36.384 36.59 42.03C61.954 47.676 75.403 63.7 77.94 90.1",
          stroke: "#979797",
          strokeDasharray: 5 }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
          d: "M77.939 99.734l-7.5-7.5 1.05-1.05 6.45 6.45 6.45-6.45 1.05 1.05z",
          fill: "#000" })] }) })));




}

/* harmony default export */ __webpack_exports__["Z"] = (SvgArrowDownCurved);

/***/ }),

/***/ 51125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}

function SvgChallengeTypeIc(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", _objectSpread(_objectSpread({ width: 28, height: 24, xmlns: "http://www.w3.org/2000/svg" }, props), {}, { children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M23 19h-6a3 3 0 00-3 3v2h2v-2a1 1 0 011-1h6a1 1 0 011 1v2h2v-2a3 3 0 00-3-3zm-7-5a4 4 0 108 0 4 4 0 00-8 0zm6 0a2 2 0 11-4 0 2 2 0 014 0zm-14 .59L5.41 12 4 13.41l4 4 7-7L13.59 9 8 14.59zM12 22H2V2h7.172l3.414 3.414.586.586H26v8h2V6a2 2 0 00-2-2H14L10.586.586A2 2 0 009.172 0H2a2 2 0 00-2 2v20a2 2 0 002 2h10v-2z",
        fill: "#FFF",
        fillRule: "evenodd" }) })));



}

/* harmony default export */ __webpack_exports__["Z"] = (SvgChallengeTypeIc);

/***/ }),

/***/ 68722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ ThreeColumnGrid; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(31157);






var CSSGrid = styled_components__WEBPACK_IMPORTED_MODULE_0__["default"].div.withConfig({ displayName: "CSSGrid", componentId: "sc-1njg7b6-0" })(["width:100%;display:grid;grid-template-columns:repeat( auto-fill,minmax(", ",1fr) );grid-gap:20px;"],




function (p) {return p.cardWidth ? "".concat(p.cardWidth, "px") : '250px';});




var ThreeColumnGrid = (0,styled_components__WEBPACK_IMPORTED_MODULE_0__["default"])(CSSGrid).withConfig({ displayName: "CSSGrid__ThreeColumnGrid", componentId: "sc-1njg7b6-1" })(["@media (min-width:", "px){grid-template-columns:repeat(auto-fill,minmax(350px,1fr));}"],
function (props) {return props.theme.viewports.tablet;});




/* harmony default export */ __webpack_exports__["Z"] = (CSSGrid);

/***/ }),

/***/ 64370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);




var TextWithIcon = function TextWithIcon(props) {return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
      mx: "-5px",
      alignItems: "center",
      justifyContent: props.rightSideIcon ? 'space-between' : 'normal',
      style: { width: props.rightSideIcon ? '100%' : 'auto' },
      className: props.className, children: [

      props.rightSideIcon ? null : /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mx: "5px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          name: props.icon,
          color: props.iconColor,
          fontSize: props.iconSize,
          style: { verticalAlign: 'middle' } }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        as: "p",
        mx: "5px",
        style: { textTransform: props.uppercase ? 'uppercase' : 'inherit' }, children:

        props.children }),

      props.rightSideIcon ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mx: "5px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          name: props.icon,
          color: props.iconColor,
          fontSize: props.iconSize }) }) :


      null] }));};



/* harmony default export */ __webpack_exports__["Z"] = (TextWithIcon);

/***/ }),

/***/ 5822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85169);
/* harmony import */ var _material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37702);
/* harmony import */ var _components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64370);
/* harmony import */ var _organisms_modals_ShareModal__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29382);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);
var _excluded = ["className"];function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}














var MenuItemShareModal = function MenuItemShareModal(props, ref) {
  var className = props.className,otherProps = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props, _excluded);
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_organisms_modals_ShareModal__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, otherProps), {}, { children:
      function children(handleOpenModal) {return /*#__PURE__*/(
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_material_ui_core_MenuItem__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { ref: ref, onClick: handleOpenModal, children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_TextWithIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
              className: className,
              icon: "ygb-icon-share",
              iconSize: "15px", children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_7__/* .Trans */ .cC, { id: "menu_more.share", message: "Share" }) }) }));} })));





};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(MenuItemShareModal));

/***/ }),

/***/ 37301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SZ": function() { return /* reexport safe */ _components_texts__WEBPACK_IMPORTED_MODULE_4__.SZ; },
/* harmony export */   "__": function() { return /* reexport safe */ _components_form_Label__WEBPACK_IMPORTED_MODULE_1__.Z; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31157);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85169);
/* harmony import */ var _components_form_Label__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25077);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4338);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45945);
/* harmony import */ var _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94997);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);









var Card = styled_components__WEBPACK_IMPORTED_MODULE_7__["default"].div.withConfig({ displayName: "BlogItemCard__Card", componentId: "sc-zble3p-0" })(["border-radius:5px;cursor:pointer;text-decoration:none;", "{object-fit:contain;}"],




_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .Ee);




var BlogItemCard = function BlogItemCard(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(Card, { className: props.className, children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 20, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { href: props.redirectUrl, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, { path: props.thumbnailUrl, objectFit: "contain" }) }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: 10, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_form_Label__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { children: props.title }) }), /*#__PURE__*/

      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, {
        mb: "10px",
        style:
        props.noTrancate ?
        {} :
        {
          height: '38px' }, children: /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, {
          dangerouslySetInnerHTML: {
            __html: props.description.substr(0, 300).replace(/<img[^>]*>/g, '') } }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { className: "ReadMore--btn", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, { href: props.redirectUrl, bold: true, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_8__/* .Trans */ .cC, { id: "metadata.read_more", message: 'Read more' }) }) })] }));




};


/* harmony default export */ __webpack_exports__["ZP"] = (BlogItemCard);

/***/ }),

/***/ 90972:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(31157);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45945);
/* harmony import */ var _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94997);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17516);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}







var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_8__["default"].div.withConfig({ displayName: "Card__Wrapper", componentId: "sc-1gywtub-0" })(["border:", ";border-radius:5px;background-color:#ffffff;overflow:hidden;a{text-decoration:none;}"],
function (props) {return props.borderless ? 'none' : '1px solid #eeeeee';});









var DescriptionWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_8__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu).withConfig({ displayName: "Card__DescriptionWrapper", componentId: "sc-1gywtub-1" })([""]);

var RedirectTo = function RedirectTo(props) {
  var params = props.redirectTo;
  if (typeof props.redirectTo === 'string') {
    params = { href: props.redirectTo };
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), _objectSpread(_objectSpread({}, params), {}, { children:
      props.children })));


};

var ThumbnailSection = function ThumbnailSection(props) {
  if (props.redirectTo) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(RedirectTo, { redirectTo: props.redirectTo, locale: props.locale, children:
        props.thumbnailUrl ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: props.thumbnailUrl,
          withRadius: true, children:

          props.thumbnailContent }) : /*#__PURE__*/


        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: "/static/playlist-empty-ic.svg",
          withRadius: true, children:

          props.thumbnailContent }) }));




  }

  if (props.href) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", { href: props.href, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
          large: props.large,
          path: props.thumbnailUrl,
          withRadius: true, children:

          props.thumbnailContent }) }));



  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
      large: props.large,
      path: props.thumbnailUrl,
      withRadius: true, children:

      props.thumbnailContent }));


};

var TitleSection = function TitleSection(props) {
  if (props.redirectTo) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(RedirectTo, { redirectTo: props.redirectTo, locale: props.locale, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle }) }));


  }
  if (props.href) {
    return /*#__PURE__*/(
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("a", { href: props.href, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle }) }));


  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardTitle */ .ll, { children: props.contentTitle });
};




















var Card = function Card(props) {
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);

  return props.large ? /*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(Wrapper, {
    className: props.className,
    borderless: props.borderless, children: /*#__PURE__*/



    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { flex: "0 0 407px", onClick: props.onClick, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ThumbnailSection, {
          href: props.href,
          redirectTo: props.redirectTo ? props.redirectTo : null,
          thumbnailContent: props.thumbnailContent,
          thumbnailUrl: props.thumbnailUrl,
          locale: locale,
          large: true }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { flex: "1", px: "25px", py: "20px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, {
          flexDirection: "column",
          justifyContent: "space-between",
          style: { height: '100%' }, children: [/*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", onClick: props.onClick, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TitleSection, {
                contentTitle: props.contentTitle,
                redirectTo: props.redirectTo,
                locale: locale }) }),


            props.contentAuthor ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentAuthor }) }) :

            null, /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children:
              props.isContentDescriptionHTML ? /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, {
                dangerouslySetInnerHTML: {
                  __html: props.contentDescription } }) : /*#__PURE__*/



              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentDescription }) })] }), /*#__PURE__*/



          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { mx: "-10px", children:
                  props.contentLeftCardLargeSection.map(function (item, index) {return /*#__PURE__*/(
                      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { px: "10px", children:
                        item }, index));}) }) }), /*#__PURE__*/




              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentRightCardLargeSection })] }) })] }) })] }) }) : /*#__PURE__*/







  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(Wrapper, {
    className: props.className,
    borderless: props.borderless, children: [/*#__PURE__*/



    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { onClick: props.onClick, children: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(ThumbnailSection, {
        href: props.href,
        redirectTo: props.redirectTo,
        thumbnailContent: props.thumbnailContent,
        thumbnailUrl: props.thumbnailUrl,
        locale: locale }) }), /*#__PURE__*/


    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { px: "25px", py: "20px", children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", onClick: props.onClick, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(TitleSection, {
          href: props.href,
          contentTitle: props.contentTitle,
          redirectTo: props.redirectTo,
          locale: locale }) }),


      props.contentAuthor ? /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { mb: "10px", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentAuthor }) }) :

      null, /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(DescriptionWrapper, { mb: "10px", children:
        props.isContentDescriptionHTML ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescriptionDivStyledP */ .DY, {
          dangerouslySetInnerHTML: {
            __html: props.contentDescription } }) : /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_4__/* .CardDescription */ .SZ, { children: props.contentDescription }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .kC, { alignItems: "center", justifyContent: "space-between", children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentCardLeftSection }), /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .xu, { children: props.contentCardRightSection })] })] })] });




};

Card.toString = Wrapper.toString;
/* harmony default export */ __webpack_exports__["Z"] = (Card);

/***/ }),

/***/ 95072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ State; },
  "C": function() { return /* binding */ NewCourseCard; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(31157);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(27816);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parse/index.js + 41 modules
var parse = __webpack_require__(35337);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isFuture/index.js
var isFuture = __webpack_require__(82644);
// EXTERNAL MODULE: ./lib/contexts/languageContext.js
var languageContext = __webpack_require__(17516);
// EXTERNAL MODULE: ./node_modules/@lingui/react/esm/index.js + 1 modules
var esm = __webpack_require__(85169);
// EXTERNAL MODULE: ./components/buttons.js
var buttons = __webpack_require__(49613);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Font.js



var Element = styled_components_browser_esm["default"].span.withConfig({ displayName: "Font__Element", componentId: "sc-1ofudiq-0" })(["font-weight:", ";font-size:", ";"],
function (props) {return props.weight ? props.weight : 'normal';},
function (props) {return props.size ? props.size : 'inherit';});


var Font = function Font(props) {return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Element, { weight: props.weight, size: props.size, children:
      props.children }));};



/* harmony default export */ var components_Font = (Font);
// EXTERNAL MODULE: ./components/layout/Grid.ts
var Grid = __webpack_require__(94007);
// EXTERNAL MODULE: ./components/texts.tsx
var texts = __webpack_require__(45945);
// EXTERNAL MODULE: ./organisms/modals/InstructorModal.tsx + 1 modules
var InstructorModal = __webpack_require__(75115);
// EXTERNAL MODULE: ./gql/generated/index.tsx
var generated = __webpack_require__(48354);
;// CONCATENATED MODULE: ./organisms/cards/NewCourseCard.tsx












var Card = styled_components_browser_esm["default"].div.withConfig({ displayName: "NewCourseCard__Card", componentId: "sc-1hxrcjp-0" })(["border-radius:5px;border:1px solid #eeeeee;overflow:hidden;", ";@media (max-width:", "){border-radius:3px;}"],



function (props) {return (
    props.state !== 'active' &&
    (0,styled_components_browser_esm.css)(["background-color:#eeeeee;"]));},


function (props) {return "".concat(props.theme.viewports.tablet, "px");});




// const ProgressBar = styled.div`
//   height: 6px;
//   width: 140px;
//   border-radius: 2px;
//   background-color: #d8d8d8;
// `;

// const ProgressBarValue = styled.div`
//   width: ${props => props.progressValue}%;
//   height: 6px;
//   background-color: ${props => props.theme.colors.primary['blue-2']};
// `;

// const ProgressBarLabel = styled.div`
//   font-size: 13px;
//   font-weight: 600;
//   color: #242424;
// `;

var State = styled_components_browser_esm["default"].div.withConfig({ displayName: "NewCourseCard__State", componentId: "sc-1hxrcjp-1" })(["position:absolute;top:0;left:0;margin:5px;display:inline-block;height:22px;line-height:22px;border-radius:5px;background-color:", ";text-align:center;color:#ffffff;font-size:11px;font-weight:500;padding-left:10px;padding-right:10px;text-transform:uppercase;"],








function (props) {return (
    props.type === generated/* ProgramCategory.Courses */.l92.Courses ?
    props.theme.colors.secondary['green-3'] :
    props.theme.colors.primary['blue-2']);});









var TopRightButton = styled_components_browser_esm["default"].div.withConfig({ displayName: "NewCourseCard__TopRightButton", componentId: "sc-1hxrcjp-2" })(["position:absolute;top:30px;right:30px;width:244px;"]);






var Thumbnail = styled_components_browser_esm["default"].div.withConfig({ displayName: "NewCourseCard__Thumbnail", componentId: "sc-1hxrcjp-3" })(["background-position:center;background-size:cover;background-image:", ";border-bottom-left-radius:2px;border-top-left-radius:2px;margin-left:-1px;margin-top:-1px;margin-bottom:-1px;position:relative;@media (max-width:", "){margin-top:-1px;margin-left:-1px;margin-right:-1px;height:0;padding-bottom:56%;border-top-left-radius:0;border-top-right-radius:0;border-bottom-left-radius:0;border-bottom-right-radius:0;overflow:hidden;}&:before{content:'';display:block;padding-bottom:65%;}"],


function (props) {return props.path ? "url(".concat(props.path, ")") : null;},






function (props) {return "".concat(props.theme.viewports.tablet, "px");});


















var ThumbnailInner = styled_components_browser_esm["default"].div.withConfig({ displayName: "NewCourseCard__ThumbnailInner", componentId: "sc-1hxrcjp-4" })(["display:block;text-decoration:none;position:absolute;top:0;bottom:0;left:0;right:0;"]);









var InstructorLabel = styled_components_browser_esm["default"].a.withConfig({ displayName: "NewCourseCard__InstructorLabel", componentId: "sc-1hxrcjp-5" })(["display:inline-block;color:", ";text-decoration:none;font-weight:600;"],

function (props) {return props.theme.colors.primary['blue-2'];});




var ThumbnailWrapper = function ThumbnailWrapper(props) {
  return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(RedirectTo, { path: props.path, locale: props.locale, children:
      props.children }));


};

var Metadata = function Metadata(props) {return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(Grid/* Flex */.kC, { justifyContent: "space-between", flexWrap: 'wrap', children: /*#__PURE__*/



















      (0,jsx_runtime.jsx)(Grid/* Box */.xu, { children: /*#__PURE__*/
        (0,jsx_runtime.jsx)(texts/* ParagraphNewCourseCard */.eQ, { italic: true, children:
          props.expirationDate ? /*#__PURE__*/
          (0,jsx_runtime.jsx)(jsx_runtime.Fragment, { children:
            (0,isSameDay/* default */.Z)(
            (0,parse/* default */.Z)(props.expirationDate, "dd/MM/yyyy", new Date()),
            new Date()) ||

            (0,isFuture/* default */.Z)((0,parse/* default */.Z)(props.expirationDate, "dd/MM/yyyy", new Date())) ? /*#__PURE__*/
            (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "metadata.expire_on",
              message: 'This course expires on {expirationDate}',
              values: { expirationDate: props.expirationDate } }) : /*#__PURE__*/


            (0,jsx_runtime.jsx)(esm/* Trans */.cC, {
              id: "metadata.expired_on",
              message: 'This course expired on {expirationDate}',
              values: { expirationDate: props.expirationDate } }) }) :



          null }) }) }));};





var WhiteWrapper = styled_components_browser_esm["default"].div.withConfig({ displayName: "NewCourseCard__WhiteWrapper", componentId: "sc-1hxrcjp-6" })(["background-color:white;position:relative;"]);



var A = styled_components_browser_esm["default"].a.withConfig({ displayName: "NewCourseCard__A", componentId: "sc-1hxrcjp-7" })(["text-decoration:none;"]);



var RedirectTo = function RedirectTo(props) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(A, { href: props.path, children: props.children });
};

var TitleSection = function TitleSection(props) {
  return props.path ? /*#__PURE__*/
  (0,jsx_runtime.jsx)(RedirectTo, { path: props.path, locale: props.locale, children: /*#__PURE__*/
    (0,jsx_runtime.jsx)(texts/* CardTitle */.ll, { children: props.contentTitle }) }) : /*#__PURE__*/


  (0,jsx_runtime.jsx)(texts/* CardTitle */.ll, { children: props.contentTitle });

};

var CourseCard = function CourseCard(props) {return /*#__PURE__*/(
    (0,jsx_runtime.jsx)(languageContext/* default.Consumer */.Z.Consumer, { children:
      function children(locale) {
        return /*#__PURE__*/(
          (0,jsx_runtime.jsxs)(_StyledFlex, {
            className: props.className,
            as: Card,
            flexDirection: ['column', 'column', 'row'],
            state: props.state,
            mb: 10, $_css:
            props.css, children: [/*#__PURE__*/

            (0,jsx_runtime.jsx)(Grid/* Box */.xu, {
              flex: ['0 auto', '0 auto', '0 407px'],
              as: Thumbnail,
              path: props.thumbnailUrl, children: /*#__PURE__*/

              (0,jsx_runtime.jsx)(ThumbnailWrapper, { path: props.path, children: /*#__PURE__*/
                (0,jsx_runtime.jsx)(ThumbnailInner, { children: /*#__PURE__*/
                  (0,jsx_runtime.jsxs)(State, { type: props.type, children: [
                    props.type === generated/* ProgramCategory.Programs */.l92.Programs ? /*#__PURE__*/
                    (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.programLabel", message: 'Program' }) :
                    null,

                    props.type === generated/* ProgramCategory.Courses */.l92.Courses ? /*#__PURE__*/
                    (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.courseLabel", message: 'Course' }) :
                    null] }) }) }) }), /*#__PURE__*/




            (0,jsx_runtime.jsx)(Grid/* Box */.xu, { flex: 1, px: "30px", py: "30px", as: WhiteWrapper, children: /*#__PURE__*/
              (0,jsx_runtime.jsxs)(Grid/* Flex */.kC, {
                flexDirection: 'column',
                justifyContent: 'space-between',
                style: { height: '100%' }, children: [/*#__PURE__*/

                (0,jsx_runtime.jsxs)(Grid/* Box */.xu, { mb: "2px", children: [/*#__PURE__*/

                  (0,jsx_runtime.jsx)(TitleSection, {
                    contentTitle: props.title,
                    path: props.path,
                    locale: locale }),

                  props.instructors && props.instructors.length > 0 ? /*#__PURE__*/
                  (0,jsx_runtime.jsxs)(texts/* ParagraphNewCourseCard */.eQ, { children: [
                    props.type === generated/* ProgramCategory.Programs */.l92.Programs ? /*#__PURE__*/
                    (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.program_by", message: 'Program by' }) :
                    null,
                    props.type === generated/* ProgramCategory.Courses */.l92.Courses ? /*#__PURE__*/
                    (0,jsx_runtime.jsx)(esm/* Trans */.cC, { id: "metadata.course_by", message: 'Course by' }) :
                    null,
                    props.instructors.map(function (instructor, index) {return /*#__PURE__*/(
                        (0,jsx_runtime.jsx)(InstructorModal/* default */.Z, { slug: instructor.slug, children:
                          function children(handleOpenModal) {return /*#__PURE__*/(
                              (0,jsx_runtime.jsx)(InstructorLabel, { onClick: function onClick() {return handleOpenModal();}, children:
                                instructor.name }));} }, index));})] }) :





                  null] }),

                props.state !== 'active' ? /*#__PURE__*/
                (0,jsx_runtime.jsx)(TopRightButton, { children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(buttons/* default */.ZP, { appearance: "outline", children: /*#__PURE__*/
                    (0,jsx_runtime.jsx)(components_Font, { weight: "600", children: "Re-purchase Course with -20% off" }) }) }) :


                null, /*#__PURE__*/
                (0,jsx_runtime.jsx)(Grid/* Box */.xu, { mb: "20px", children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(texts/* ParagraphNewCourseCard */.eQ, { children:
                    props.description }) }), /*#__PURE__*/


                (0,jsx_runtime.jsx)(Grid/* Box */.xu, { children: /*#__PURE__*/
                  (0,jsx_runtime.jsx)(Metadata, {
                    progressValue: props.progressValue,
                    state: props.state,
                    expirationDate: props.expirationDate,
                    completionDate: props.completionDate }) })] }) })] }));






      } }));};



/* harmony default export */ var NewCourseCard = (CourseCard);var _StyledFlex = (0,styled_components_browser_esm["default"])(Grid/* Flex */.kC).withConfig({ displayName: "NewCourseCard___StyledFlex", componentId: "sc-1hxrcjp-8" })(["", ""], function (p) {return p.$_css;});

/***/ }),

/***/ 84882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(85169);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31157);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(42298);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42227);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54444);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94007);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45945);
/* harmony import */ var _ecosystems_MenuItemShareModal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5822);
/* harmony import */ var _organisms_cards_Card__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90972);
/* harmony import */ var _NewCourseCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95072);
/* harmony import */ var _gql_generated__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48354);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);












var RightSectionThumbnailWrapper = styled_components__WEBPACK_IMPORTED_MODULE_9__["default"].div.withConfig({ displayName: "ProgramCard__RightSectionThumbnailWrapper", componentId: "sc-11mipso-0" })(["position:absolute;width:100px;height:100%;top:0;right:0;background-color:", ";border-radius:0 3px 0 0;"],





function (props) {return (
    props.type === _gql_generated__WEBPACK_IMPORTED_MODULE_7__/* .ProgramCategory.Courses */ .l92.Courses ?
    'rgb(136,191,189, 0.9)' :
    'rgba(86, 185, 229, 0.9)');});



var ProgramCard = function ProgramCard(props) {
  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_organisms_cards_Card__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      className: props.className,
      href: props.program.path,
      thumbnailUrl: props.program.thumbnailUrl,
      thumbnailContent: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, { children: [
        props.type && /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_NewCourseCard__WEBPACK_IMPORTED_MODULE_6__/* .State */ .Z, { type: props.type, children: [
          props.type === _gql_generated__WEBPACK_IMPORTED_MODULE_7__/* .ProgramCategory.Courses */ .l92.Courses ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "metadata.programLabel", message: 'Program' }) :
          null,

          props.type === _gql_generated__WEBPACK_IMPORTED_MODULE_7__/* .ProgramCategory.Courses */ .l92.Courses ? /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "metadata.courseLabel", message: 'Course' }) :
          null] }),


        props.tags ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { mt: "5px", ml: "4px", children:
          props === null || props === void 0 ? void 0 : props.tags }) :

        null,
        props.program.accessUntil ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(RightSectionThumbnailWrapper, { type: props.type, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            p: "15px",
            style: { height: '100%' }, children: [/*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xu, { mb: "10px", style: { textAlign: 'center' }, children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                name: "ygb-icon-program-ic",
                fontSize: "32px",
                color: "white" }) }), /*#__PURE__*/


            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, { flexDirection: "column", children: [/*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .ProgramCardDuration */ .sv, { children: /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_10__/* .Trans */ .cC, { id: "metadata.accessUntil", message: "Access Until" }) }), /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_3__/* .ProgramCardDuration */ .sv, { children:
                (0,date_fns__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(
                (0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(props.program.accessUntil),
                'dd/MM/yyyy') })] })] }) }) :





        null,
        props.customRightSection ? props.customRightSection : null] }),


      contentTitle: props.program.title,
      isContentDescriptionHTML: true,
      contentDescription: props.program.description,
      contentCardLeftSection:
      props.favoritable ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", { children: "Favorite a program" }) : null,

      contentCardRightSection: /*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_ecosystems_MenuItemShareModal__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        resourceIdentifier: props.program.path,
        resource: "program" }) }));




};
/* harmony default export */ __webpack_exports__["Z"] = (ProgramCard);

/***/ }),

/***/ 68632:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CHALLENGE_CODE": function() { return /* binding */ CHALLENGE_CODE; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(90116);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(31157);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lingui_react__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(85169);
/* harmony import */ var _ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83689);
/* harmony import */ var _ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23502);
/* harmony import */ var _components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94007);
/* harmony import */ var _components_SectionHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70300);
/* harmony import */ var _components_InstructorMeta__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95240);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(54444);
/* harmony import */ var _material_ui_icons_Spa__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(26494);
/* harmony import */ var _material_ui_icons_CloudDownload__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(9248);
/* harmony import */ var _material_ui_icons_PlaylistAdd__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(63123);
/* harmony import */ var _lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17516);
/* harmony import */ var _components_MessageStripe__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35281);
/* harmony import */ var _components_texts__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45945);
/* harmony import */ var _components_CSSGrid__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(68722);
/* harmony import */ var _components_MetaTags__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(9128);
/* harmony import */ var _components_Carousel__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(22047);
/* harmony import */ var _organisms_cards_BlogItemCard__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(37301);
/* harmony import */ var _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94997);
/* harmony import */ var _components_buttons__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(49613);
/* harmony import */ var _organisms_cards_ProgramCard__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(84882);
/* harmony import */ var _assets_ChallengeTypeIc__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(51125);
/* harmony import */ var _assets_ArrowDownCurved__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(12265);
/* harmony import */ var _lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(47493);
/* harmony import */ var _ecosystems_pricing_PricingSection__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(27352);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(85893);
function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {(0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}





























var GoldButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(_components_buttons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP).withConfig({ displayName: "challenge__GoldButton", componentId: "sc-nce5qd-0" })(["color:#45350C;margin-right:10px;"]);




var GoldOutline = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(GoldButton).withConfig({ displayName: "challenge__GoldOutline", componentId: "sc-nce5qd-1" })(["border-color:#CCB375;padding-top:11px;padding-bottom:11px;"]);





var MessageStripe = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(_components_MessageStripe__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .ZP).withConfig({ displayName: "challenge__MessageStripe", componentId: "sc-nce5qd-2" })(["p{font-size:14px;font-weight:500;margin:10px auto;}"]);







var HeroSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(_ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({ displayName: "challenge__HeroSection", componentId: "sc-nce5qd-3" })(["b{color:#253238;white-space:nowrap;}", "{padding-right:8%;margin:0 auto;", "{max-width:720px;}", "{display:flex;align-items:center;font-size:34px;line-height:1.2;margin-bottom:0px;span{font-size:11px;color:", ";font-weight:500;border-radius:3px;padding:5px;margin-left:12px;background-color:#129EDC;}}", "{font-size:20px;line-height:1.4;margin-top:24px;margin-bottom:20px;}", "{max-width:400px;font-size:13px;margin-top:10px;}@media (max-width:", "px){", "{font-size:24px;}margin-top:20px;}@media (max-width:", "px){padding-right:0;}}", "{display:flex;align-items:center;}"],





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapper */ .OP,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapperInner */ .z5,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx,








function (_ref) {var theme = _ref.theme;return theme.colors.neutrals.white;},








_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .SubTitle */ .DK,






_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .Disclaimer */ .em,





function (props) {return props.theme.viewports.tablet;},
_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx,





function (props) {return props.theme.viewports.mobile;},




_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .VideoWrapper */ .U1);





var StepByStepSection = styled_components__WEBPACK_IMPORTED_MODULE_24__["default"].div.withConfig({ displayName: "challenge__StepByStepSection", componentId: "sc-nce5qd-4" })(["background-color:#FAF7F1;"]);



var StepsTitle = styled_components__WEBPACK_IMPORTED_MODULE_24__["default"].p.withConfig({ displayName: "challenge__StepsTitle", componentId: "sc-nce5qd-5" })(["font-size:20px;"]);



var StepSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(_ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({ displayName: "challenge__StepSection", componentId: "sc-nce5qd-6" })(["width:100%;flex-direction:column;align-items:center;margin-bottom:40px;&.StepSection--First{", " ", "{background-size:auto 100%;background-repeat:no-repeat;}}", "{width:100%;", "{max-width:540px;align-items:center;text-align:center;margin:0 auto;}", "{font-size:22px;margin-bottom:20px;}", "{font-size:16px;line-height:24px;}}", "{max-width:620px;width:100%;border-radius:30px;padding:60px 0px;background-color:rgba(205,180,119,0.4);", " ", "{background-color:unset;}}@media(min-width:", "px){flex-direction:row-reverse;&:nth-of-type(even){flex-direction:row;", "{padding-left:10%;}}", "{width:50%;", "{align-items:initial;text-align:left;}}", "{width:50%;}}"],






_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_16__/* ["default"].toString */ .ZP.toString(), _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_16__/* .BackgroundImage */ .Xd,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapper */ .OP,


_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapperInner */ .z5,






_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx,




_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .SubTitle */ .DK,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .VideoWrapper */ .U1,






_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_16__/* ["default"].toString */ .ZP.toString(), _components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_16__/* .BackgroundImage */ .Xd,





function (_ref2) {var theme = _ref2.theme;return theme.viewports.laptop;},





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapper */ .OP,




_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapper */ .OP,


_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapperInner */ .z5,





_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .VideoWrapper */ .U1);





var FeaturesSection = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2).withConfig({ displayName: "challenge__FeaturesSection", componentId: "sc-nce5qd-7" })(["display:flex;flex-direction:column;padding:60px 20px;background-color:#D9E8E7;.swiper-wrapper{max-width:1280px;margin:0 auto;}"]);











var FeatureCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(_organisms_cards_BlogItemCard__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .ZP).withConfig({ displayName: "challenge__FeatureCard", componentId: "sc-nce5qd-8" })(["width:320px !important;height:auto;padding:15px 20px 50px;margin-right:20px;background-color:", ";cursor:unset;@media(min-width:", "px){width:380px !important;}@media(min-width:", "px){width:400px !important;}", "{display:flex;align-items:center;padding-top:20px;", "{position:static;width:100px;height:100px;border-radius:50%;margin:0 auto;padding:20px;box-sizing:content-box;background-size:100px;background-repeat:no-repeat;background-color:rgba(136,191,188,0.3);}}", "{display:block;font-size:18px;font-weight:700;text-align:center;}", "{height:auto !important;font-size:14px;text-align:center;-webkit-line-clamp:unset;-webkit-box-orient:unset;}.ReadMore--btn{display:none;}"],




function (_ref3) {var theme = _ref3.theme;return theme.colors.neutrals.white;},


function (_ref4) {var theme = _ref4.theme;return theme.viewports.tablet;},



function (_ref5) {var theme = _ref5.theme;return theme.viewports.laptop;},



_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_16__/* ["default"].toString */ .ZP.toString(),




_components_ThumbnailWithRatio__WEBPACK_IMPORTED_MODULE_16__/* .BackgroundImage */ .Xd,













_organisms_cards_BlogItemCard__WEBPACK_IMPORTED_MODULE_15__/* .Label.toString */ .__.toString(),






_organisms_cards_BlogItemCard__WEBPACK_IMPORTED_MODULE_15__/* .CardDescription */ .SZ);












var ProgramsWrapper = styled_components__WEBPACK_IMPORTED_MODULE_24__["default"].div.withConfig({ displayName: "challenge__ProgramsWrapper", componentId: "sc-nce5qd-9" })(["width:100%;display:grid;grid-template-columns:repeat(auto-fit,minmax(320px,1fr));grid-gap:20px;"]);






var ProgramCategory = styled_components__WEBPACK_IMPORTED_MODULE_24__["default"].p.withConfig({ displayName: "challenge__ProgramCategory", componentId: "sc-nce5qd-10" })(["position:absolute;top:0;right:0;display:flex;flex-direction:column;align-items:center;justify-content:center;width:100px;height:100%;color:", ";font-weight:500;border-radius:0 3px 0 0;margin:0;background-color:rgba(204,179,117,.9);"],









function (_ref6) {var theme = _ref6.theme;return theme.colors.neutrals.white;});






var ProgramCard = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(_organisms_cards_ProgramCard__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z).withConfig({ displayName: "challenge__ProgramCard", componentId: "sc-nce5qd-11" })(["max-width:90vw;"]);




var PerksWrapper = styled_components__WEBPACK_IMPORTED_MODULE_24__["default"].div.withConfig({ displayName: "challenge__PerksWrapper", componentId: "sc-nce5qd-12" })(["position:relative;"]);



var PerksHero = (0,styled_components__WEBPACK_IMPORTED_MODULE_24__["default"])(_ecosystems_landing_pages_hero_Hero__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({ displayName: "challenge__PerksHero", componentId: "sc-nce5qd-13" })(["width:100%;max-width:1240px;padding:40px 20px;margin:40px 0;background-color:", ";;", "{width:100%;margin:0 auto;", "{font-size:34px;color:", ";font-weight:500;}", "{font-size:14px;}", "{max-width:400px;color:", ";font-size:13px;margin-top:10px;}button{color:", ";}}", "{display:none;}@media(min-width:1024px){padding-left:60px;padding-right:60px;margin-left:20px;margin-right:20px;", "{width:50%;}", "{display:initial;align-self:center;width:256px;height:256px;margin:0 auto;[data-bg]{background-color:unset;background-size:contain;background-repeat:no-repeat;}}}"],




function (_ref7) {var theme = _ref7.theme;return theme.colors.channels.meditation;},


_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapper */ .OP,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .Title */ .Dx,

function (_ref8) {var theme = _ref8.theme;return theme.colors.neutrals.white;},



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .Paragraph */ .nv,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .Disclaimer */ .em,

function (_ref9) {var theme = _ref9.theme;return theme.colors.neutrals.white;},





function (_ref10) {var theme = _ref10.theme;return theme.colors.channels.meditation;},



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .VideoWrapper */ .U1,









_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .TextWrapper */ .OP,



_ecosystems_landing_pages_hero_components__WEBPACK_IMPORTED_MODULE_4__/* .VideoWrapper */ .U1);















var List = styled_components__WEBPACK_IMPORTED_MODULE_24__["default"].ul.withConfig({ displayName: "challenge__List", componentId: "sc-nce5qd-14" })(["color:", ";font-size:16px;line-height:1.4;padding-left:0;list-style:none;li{display:flex;align-items:center;margin-bottom:20px;i:before{font-size:18px;}}"],
function (_ref11) {var theme = _ref11.theme;return theme.colors.neutrals.white;});
















var testimonials = {
  title: 'Vad säger våra medlemmar?',
  testimonials: [
  {
    name: 'Sharon',
    shortDescription: '26  år från Göteborg',
    testimonial:
    '“Jag har använt Yogobe i ett par månader nu och älskar hur varierad min yogapraktik och träning blivit!”',
    thumbnail: '/static/testimonials/image1.jpg',
    squareImage: '/static/testimonials/image1.jpg' },

  {
    name: 'Susanne von Hebel',
    shortDescription: '46 år från Hisings backa',
    testimonial:
    '“Yogobe har verkligen varit min räddning det här senaste året. Jag älskar att träna hemifrån! Det finns alltid någon ny klass att upptäcka, eller någon gammal favorit att återvända till.”',
    thumbnail: '/static/testimonials/image2.jpg',
    squareImage: '/static/testimonials/image2.jpg' },

  {
    name: 'Josefin',
    shortDescription: '33 år från Kungsbacka',
    testimonial:
    '“Det var inte förrän under min graviditet som jag hittade Yogobe. Nu kör jag ett par pass i veckan. Varvar klasser från “Mammamage” med Yoga Nidra.”',
    thumbnail: '/static/testimonials/image3.jpg',
    squareImage: '/static/testimonials/image3.jpg' }] };




var hereBannerList = [
{
  icon: 'ygb-icon-playlist',
  text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.list_item1" }) },

{
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_material_ui_icons_CloudDownload__WEBPACK_IMPORTED_MODULE_26__/* ["default"] */ .Z, {}),
  text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.list_item2" }) },

{
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_material_ui_icons_Spa__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {}),
  text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.list_item3" }) },

{
  icon: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_material_ui_icons_PlaylistAdd__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {}),
  text: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.list_item4" }) }];



var Tag = styled_components__WEBPACK_IMPORTED_MODULE_24__["default"].span.withConfig({ displayName: "challenge__Tag", componentId: "sc-nce5qd-15" })(["display:inline-block;font-size:11px;font-weight:600;line-height:12px;text-transform:uppercase;margin-right:5px;padding:5px;border-radius:3px;", ";i{margin-right:3px;}"],








function (_ref12) {var _ref12$bg = _ref12.bg,bg = _ref12$bg === void 0 ? '#CDB477' : _ref12$bg,_ref12$color = _ref12.color,color = _ref12$color === void 0 ? '#45350C' : _ref12$color;return "color:".concat(
  color, "; background-color: ").concat(bg, ";");});






var CHALLENGE_PROGRAMS = [
{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: '21-dagar-vardagsstark',
    path: 'programs/21-dagar-vardagsstark/overview',
    title: 'Vardagsstark 21 dagar',
    thumbnailUrl:
    'https://yogobe-assets-shrine-production.s3.eu-north-1.amazonaws.com/yogobe-production/uploads/store/image/e00004e0-d69c-46eb-a266-b26d085849d1/image/cbcf39e417dd5952b8952b03f57c3f0b.jpg',
    description:
    'En tre veckor lång utmaning med inspiration och vägledning till mer rörelse och återhämtning i vardagen!',
    category: 'Hållbarhet' } },


// {
//   tags: [
//     <Tag key={0}>
//       <Trans id="challenge_2021.metadata.tags.challenge" />
//     </Tag>,
//   ],
//   program: {
//     slug: 'mindfulness-kalender',
//     path: 'programs/mindfulness-kalender/overview',
//     title: 'Mindfulnesskalendern 2022',
//     thumbnailUrl:
//       'https://yogobe-assets-shrine-production.s3.eu-north-1.amazonaws.com/yogobe-production/uploads/store/image/d7dbd0b9-cc40-427c-a1d4-2f20d1a4ce2e/image/d27aa12f805f36626e3fcb5d45b5bda2.png',
//     description:
//       'En julkalender för dig som vill varva ner inför julen! Avsluta året med ett inre lugn och kliv in i det nya med närvaro, fokus och glädje.',
//     category: 'Julkalender',
//   },
// },
{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: 'vakna-yogobe',
    title: 'Vakna med Yogobe',
    path: 'programs/vakna-yogobe/overview',
    thumbnailUrl:
    'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/images/images/d76/3a2/9d-/original/vakna_med_yogobe.jpeg?1656833846',
    description:
    'En utmaning som pågår under fyra veckor, med tre typer av sköna morgonklasser varje vecka!',
    category: 'Mjukstarta' } },


{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: '16-weeks-of-well',
    path: 'programs/16-weeks-of-well/overview',
    title: '16 veckor med Yogobe',
    thumbnailUrl:
    'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/images/images/81f/388/a9-/original/16_Weeks_of_Well_ha%CC%88lsa_yoga_tra%CC%88ning_rutiner_Yogobe.jpg?1649325583',
    description:
    'Ett 16 veckors utmaning för dig som vill få inspiration och stöd för ett ökat välmående, på alla plan.',
    category: 'Välmående' } },


{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: '7-day-kickstart',
    path: 'programs/7-day-kickstart/overview',
    title: '7 day challenge',
    thumbnailUrl:
    'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/images/images/1f7/0d3/15-/original/7daychallenge_program_page.jpg?1644405581',
    description:
    'För dig som vill komma igång med Yogobe och hitta glädjen i rutinen.',
    category: 'Kickstarta' } },


{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: 'beginner-baby',
    path: 'programs/beginner-baby/overview',
    title: 'Beginner baby',
    description:
    'För dig som vill komma igång med enkel träning & känna träningsglädje.',
    thumbnailUrl:
    'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/media_objects/images/93d/26d/7c-/original/Beginner-baby.jpg?1613037445',

    category: 'Nybörjare' } },


{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: 'strong-and-graceful',
    path: 'programs/strong-and-graceful/overview',
    title: 'Strong & Graceful',
    description: 'För dig som vill utmanas i såväl yoga som hållbar träning.',
    thumbnailUrl:
    'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/media_objects/images/de0/566/ff-/original/Strong-graceful.jpg?1613037499',

    category: 'Rörlighet' } },


{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: 'restore-and-relax',
    path: 'programs/restore-and-relax/overview',
    title: 'Restore & Relax',
    description:
    'Ett program för dig som upplever stress, smärta eller utmattning.',
    thumbnailUrl:
    'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/media_objects/images/77d/220/ad-/original/Relax-restore.jpg?1613037483',
    category: 'Relax' } },


{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: 'holy-trinity',
    path: 'programs/holy-trinity/overview',
    title: 'Holy Trinity',
    description:
    'För dig som vill utveckla din asana, fördjupa dig inom filosofi & spiritualism.',
    thumbnailUrl:
    'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/media_objects/images/e81/f6d/cd-/original/Holy-trinity.jpg?1613037466',
    category: 'Avancerat' } },


{
  tags: [/*#__PURE__*/
  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(Tag, { children: /*#__PURE__*/
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.challenge" }) }, 0)],


  program: {
    slug: 'athlete-junkie',
    path: 'programs/athlete-junkie/overview',
    title: 'Athlete Junkie',
    description:
    'För dig som vill få en fysisk utmaning som ger märkbara resultat.',
    thumbnailUrl:
    'https://s3.eu-north-1.amazonaws.com/productionyogobestaticassets20200305182457522400000001/media_objects/images/c01/75a/53-/original/Athlete-junkies.jpg?1613037397',
    category: 'Svettas' } }];




var FEATURES = [
{
  thumbnailUrl: '/static/icons/mobility.svg',
  title: 'Kom igång',
  description:
  'Behöver du motivation för att komma igång med träningen , kanske efter en paus utan? Vår challenge "Beginner, baby" erbjuder enkel och fysisk träning, varvat med nybörjaryoga, pilates och enkel mindfulness.' },

{
  thumbnailUrl: '/static/icons/stress.svg',

  title: 'Hantera stress',
  description:
  'Genom att fylla på med återhämtande yinyoga, introspektiv meditation och energigivande restorative flow ges du verktygen att hantera kropp och själ efter en längre period av stress och oro. Utforska vårt program "Relax & Restore".' },

{
  thumbnailUrl: '/static/icons/athletes.svg',
  title: 'Varierad träning',
  description:
  'Träning och rörelse är en naturlig del av din vardag, men du behöver fylla på med en variation för att stärka din grund - därför passar utmaningen "Strong & graceful" dig alldeles utmärkt. I denna får du en mix av styrka, mobilitetsträning, dynamisk yoga och prehab.' }];var __N_SSP = true;



var CHALLENGE_CODE = 'challenge_2021';
var YogobeChallenge2021 = function YogobeChallenge2021() {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
  var locale = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_languageContext__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z);
  var _useContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_lib_contexts_UserProvider__WEBPACK_IMPORTED_MODULE_21__/* .UserContext */ .S),currentUser = _useContext[0],loading = _useContext[1].loading;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (locale !== 'se') {
      router.replace('/[lang]/challenge', '/se/challenge');
    }
  }, []);

  var handleJoinClick = function handleJoinClick(params) {
    if (currentUser !== null && currentUser !== void 0 && currentUser.id) {
      router.push({
        pathname: "/".concat(locale, "/subscription/select"),
        query: _objectSpread(_objectSpread({}, params), {}, { to: router.asPath, campaign: 'Challenge' }) });

    } else {
      router.push({
        pathname: "/".concat(locale, "/register/account"),
        query: _objectSpread(_objectSpread({},
        params), {}, {
          to: encodeURI("/".concat(locale, "/challenge")),
          campaign: 'Challenge' }) });


    }
  };

  if (loading || currentUser === undefined) {
    return null;
  }

  return /*#__PURE__*/(
    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.Fragment, { children: [/*#__PURE__*/
      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_MetaTags__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
        title: "YOGOBE | Challenge",
        description: "Investera i din h\xE4lsa. Bara 4 veckor. V\xE4lj 1 av 5 utmaningar - 100% anpassade f\xF6r att m\xF6ta dina behov, vare sig du \xE4r nyb\xF6rjare, erfaren atlet, l\xF6pare eller yogaentusiast. Testa 14 dagar gratis, bes\xF6k yogobe.com/challenge.",
        thumbnailUrl: "/static/Stocksy_txp16b150167qy200_Small_3367386.jpg" }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)("div", { children: /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(MessageStripe, {
          bg: "#CCB375",
          color: "#45350C",
          closable: false,
          show: !(currentUser !== null && currentUser !== void 0 && currentUser.id), children: /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.banner.discount_text" }) }) }), /*#__PURE__*/


      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)("div", { style: { backgroundColor: '#FAF7F1' }, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { flexDirection: 'column', px: [25, 20, 20], py: 40, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(HeroSection, {
            title: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, {
              id: "challenge_2021.listing_page.hero.title",
              components: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)("span", {}, "0")] }),


            subtitle:
            currentUser !== null && currentUser !== void 0 && currentUser.id ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.listing_page.hero.premium_desc" }) : /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.listing_page.hero.no_premium_desc" }),


            actions: [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(
            currentUser !== null && currentUser !== void 0 && currentUser.id ?
            [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(GoldButton, {

              appearance: "default-gold",
              href: "#challenges", children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.explore_challenges_btn" }) }, 0)] :


            [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(GoldButton, {

              appearance: "default-gold",
              onClick: function onClick() {return handleJoinClick({ code: CHALLENGE_CODE });}, children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.get_started_btn" }) }, 0)]), [/*#__PURE__*/


            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(GoldOutline, { href: "#more-info", appearance: "outline", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.how_it_works_btn" }) }, 1)]),


            image: "/static/challenge_social.jpg",
            disclaimer:
            currentUser !== null && currentUser !== void 0 && currentUser.id ? /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.listing_page.hero.premium_disclaimer" }) : /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.listing_page.hero.no_premium_disclaimer" }),


            reverseColumns: true }) }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { id: "challenges", my: 40, px: 20, children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { flexDirection: "column", children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, { mb: "30px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.challenges_section.title" }) }) }), /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(ProgramsWrapper, { children:
            CHALLENGE_PROGRAMS.map(function (item, i) {var _currentUser$programA, _currentUser$programA2;
              var tags = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(item.tags);
              var hasAccess = currentUser === null || currentUser === void 0 ? void 0 : (_currentUser$programA = currentUser.programAccess) === null || _currentUser$programA === void 0 ? void 0 : (_currentUser$programA2 = _currentUser$programA.find) === null || _currentUser$programA2 === void 0 ? void 0 : _currentUser$programA2.call(_currentUser$programA,
              function (access) {return access.program.slug === item.program.slug;});


              if (hasAccess) {
                tags.push( /*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(Tag, { bg: "#32847E", color: "#fff", children: [/*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, { name: "ygb-icon-checkmark", color: "inherit" }), /*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.tags.participating" })] }, 1));


              }

              return /*#__PURE__*/(
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(ProgramCard, _objectSpread(_objectSpread({},

                item), {}, {
                  program: _objectSpread(_objectSpread({},
                  item.program), {}, {
                    path: "".concat("https://devenv.yogobe.com", "/").concat(locale, "/").concat(item.program.path, "?challenge") }),

                  tags: tags,
                  customRightSection: /*#__PURE__*/
                  (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(ProgramCategory, { children: [/*#__PURE__*/
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_assets_ChallengeTypeIc__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {}),
                    item.program.category] }) }), i));




            }) })] }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(FeaturesSection, { fullWidth: true, children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { flexDirection: "column", children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, { mb: "30px", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
              title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.features_section.title" }) }) }), /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_Carousel__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, { itemPerView: 3, children:
            FEATURES.map(function (feature, i) {return /*#__PURE__*/(
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(FeatureCard, _objectSpread({ noTrancate: true }, feature), i));}) })] }),



        !(currentUser !== null && currentUser !== void 0 && currentUser.id) ? /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, { justifyContent: "center", alignItems: "center", mt: 30, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
            appearance: "default-gold",
            onClick: function onClick() {return handleJoinClick({ code: CHALLENGE_CODE });}, children: /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.start_now_btn" }) }) }) : /*#__PURE__*/



        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, { justifyContent: "center", alignItems: "center", mt: 30, children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, { appearance: "default-gold", href: "#challenges", children: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.explore_challenges_btn" }) }) })] }), /*#__PURE__*/




      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(StepByStepSection, { id: "more-info", children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { flexDirection: "column", px: [15, 20, 20], pt: 60, children: [/*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Flex */ .kC, {
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            mb: 40, children: [/*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(StepsTitle, { children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.title" }) }), /*#__PURE__*/

            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_assets_ArrowDownCurved__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {})] }), /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(StepSection, {
            className: "StepSection--First",
            image: "/static/challenge-step1.png",
            title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.step1.title" }),
            subtitle: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.step1.desc" }),
            actions: [].concat((0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z)(
            !(currentUser !== null && currentUser !== void 0 && currentUser.id) ?
            [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {

              appearance: "default-purple",
              onClick: function onClick() {return handleJoinClick({ code: CHALLENGE_CODE });}, children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.get_started_btn" }) }, 0)] :


            []), [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(GoldOutline, { href: "#challenges", appearance: "outline", children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.browse_challenges" }) }, 1)]),


            reverseColumns: true }), /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(StepSection, {
            image: "/static/challenge-step2.png",
            title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.step2.title" }),
            subtitle: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.step2.desc" }),
            disclaimer: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.listing_page.hero.premium_disclaimer" }) }), /*#__PURE__*/


          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(StepSection, {
            image: "/static/challenge-step3.png",
            title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.step3.title" }),
            subtitle: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.step3.desc" }),
            actions:
            !(currentUser !== null && currentUser !== void 0 && currentUser.id) ?
            [/*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_buttons__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {

              appearance: "default-purple",
              onClick: function onClick() {return handleJoinClick({ code: CHALLENGE_CODE });}, children: /*#__PURE__*/

              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.get_started_btn" }) }, 0)] :


            [],

            reverseColumns: true }), /*#__PURE__*/

          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(StepSection, {
            image: "/static/challenge-step4.png",
            title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.step4.title" }),
            subtitle: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.steps_section.step4.desc" }) })] }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { flexDirection: "column", my: [25, 40, 40], px: [15, 20, 20], children: [/*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, { mb: "50px", children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_SectionHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { title: testimonials.title }) }), /*#__PURE__*/

        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_CSSGrid__WEBPACK_IMPORTED_MODULE_12__/* .ThreeColumnGrid */ .w, { children:
          testimonials.testimonials.map(function (testimonial) {return /*#__PURE__*/(
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .xu, { mb: 40, children: [/*#__PURE__*/
                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_InstructorMeta__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                  isClickable: false,
                  instructor: {
                    thumbnailUrl: testimonial.thumbnail,
                    name: testimonial.name,
                    shortDescription: testimonial.shortDescription } }), /*#__PURE__*/


                (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_texts__WEBPACK_IMPORTED_MODULE_11__/* .TestimonialStatic */ .g6, { children: testimonial.testimonial })] }, testimonial.name));}) })] }), /*#__PURE__*/




      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(PerksWrapper, { children: /*#__PURE__*/
        (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_layout_Grid__WEBPACK_IMPORTED_MODULE_5__/* .Container */ .W2, { children: /*#__PURE__*/
          (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(PerksHero, _objectSpread(_objectSpread({
            title: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "landing_page.offer.blue_section.title" }),
            image: "/static/onboarding-step2.png",
            description: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.Fragment, { children: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(List, { children:
                hereBannerList.map(function (item, i) {return /*#__PURE__*/(
                    (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsxs)("li", { children: [
                      typeof item.icon === 'string' ? /*#__PURE__*/
                      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_components_Icon__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        fontSize: "14px",
                        name: item.icon }) :


                      item.icon, /*#__PURE__*/

                      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)("span", { style: { marginLeft: '10px' }, children: item.text })] }, i));}) }) }) },





          !(currentUser !== null && currentUser !== void 0 && currentUser.id) ?
          {
            actions: [
            {
              name: /*#__PURE__*/
              (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.metadata.start_now_btn" }),

              theme: 'default-white',
              onClick: function onClick() {return handleJoinClick({ code: CHALLENGE_CODE });} }],


            disclaimer: /*#__PURE__*/
            (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_lingui_react__WEBPACK_IMPORTED_MODULE_25__/* .Trans */ .cC, { id: "challenge_2021.listing_page.hero.no_premium_disclaimer" }) } :


          {}), {}, {
            reverseColumns: true })) }) }), /*#__PURE__*/



      (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_23__.jsx)(_ecosystems_pricing_PricingSection__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .ZP, { promotionCode: "challenge_2021" })] }));


};












/* harmony default export */ __webpack_exports__["default"] = (YogobeChallenge2021);

/***/ })

}]);